module.exports = __webpack_public_path__ + "img/emi-porta-2.89009eb4.png";